module.exports = __webpack_public_path__ + "img/bwg7.203b19a7.png";